<template>
    <div style="display: inline-block">
        <div
            ref="triggerRef"
            class="trigger-wrapper"
            tabindex="0"
            aria-describedby="tooltip-content"
            @mouseover="(e) => { showHideTooltip(true, e) }" @mouseleave="(e) => { showHideTooltip(false, e) }"
            @keydown.enter="(e) => { showHideTooltip(!showTooltip, e) }"
            @keydown.space="(e) => { showHideTooltip(!showTooltip, e) }">
            <slot name="trigger"></slot>
        </div>

        <Teleport to="body">
            <div
                v-show="showTooltip"
                :id="randomId"
                ref="contentRef"
                role="tooltip"
                class="tooltip"
                :style="positionStyles" tabindex="0"
                @blur="(e) => { showHideTooltip(false, e); }"
                @mouseleave="(e) => { showHideTooltip(false, e) }">
                <slot name="content"></slot>
            </div>
        </Teleport>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
    position: {
        type: String,
        default: 'bottom',
        validator: (value) => ['top', 'bottom', 'left', 'right', 'bottom-right'].includes(value),
    },
});

const showTooltip = ref(false);
const triggerRef = ref();
const triggerRectRef = ref({})
const contentRef = ref();
const contentRectRef = ref({})
const randomId = Math.random().toString(36).substring(2, 12)

const getFocusableDescendants = (element) => {
    const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
    const focusableElements = element?.querySelectorAll(focusableElementsSelector);
    return focusableElements;
}


const showHideTooltip = (bool, e) => {
    if (e.relatedTarget?.closest('.tooltip') || e.relatedTarget?.closest('.trigger-wrapper')) {
        return
    }
    showTooltip.value = bool

    if (bool === true) {
        // Needs to be refactored
        setTimeout(() => {
            triggerRectRef.value = getTriggerPosition();
            contentRectRef.value = getContentPosition();
        }, 10)
        setTimeout(() => {
            contentRef.value.focus({ focusVisible: true });
        },30)
    } else {
        focusTrigger()
    }
}

const focusTrigger = () => {
    triggerRef.value?.focus({ focusVisible: true })
}

const getTriggerPosition = () => {
    return triggerRef?.value?.getBoundingClientRect()
}

const getContentPosition = () => {
    return contentRef?.value?.getBoundingClientRect()
}

const positionStyles = computed(() => {
    switch (props.position) {
        case 'bottom':
            return {
                left: `${triggerRectRef.value.left - (contentRectRef.value.width / 2) + (triggerRectRef.value.width / 2)}px`,
                top: `${triggerRectRef.value.top + triggerRectRef.value.height}px`
            }
        case 'top':
            return {
                left: `${triggerRectRef.value.left - (contentRectRef.value.width / 2) + (triggerRectRef.value.width / 2)}px`,
                top: `${triggerRectRef.value.top - contentRectRef.value.height + window.pageYOffset}px`
            }
        case 'left':
            return {
                left: `${triggerRectRef.value.left - (contentRectRef.value.width)}px`,
                top: `${triggerRectRef.value.top}px`
            }
        case 'right':
            return {
                left: `${triggerRectRef.value.left + triggerRectRef.value.width}px`,
                top: `${triggerRectRef.value.top}px`
            }
        case 'bottom-right':
            return {
                left: `${triggerRectRef.value.right - (contentRectRef.value.width)}px`,
                top: `${triggerRectRef.value.top + triggerRectRef.value.height}px`
            }
        default:
            return {
                left: `0px`,
                top: `0px`
            }
    }
});

onMounted(() => {
    const children = getFocusableDescendants(contentRef.value)
    children?.forEach(element => {
        element?.addEventListener('blur', (e) => { showHideTooltip(false, e) })
    });
})

onUnmounted(() => {
    const children = getFocusableDescendants(contentRef.value)
    children?.forEach(element => {
        element?.removeEventListener('blur', (e) => { showHideTooltip(false, e) })
    });
})
</script>
